export default __webpack_public_path__ + "static/media/ic_totaluser.abedd34c.svg";